


























import Vue from 'vue'

export default Vue.extend({
  name: 'ListingItemEl',

  props: {
    templateItemData: {
      type: Object,
      required: true
    }
  }
})
